function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQualityProductIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8394"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 35821",
    d: "M102.312 8.4H91.927a1.26 1.26 0 0 0-1.264 1.258v10.12a4.315 4.315 0 0 0-1.856 1.5l-.693 1.013a.516.516 0 0 0 .846.59l.7-1.013a3.285 3.285 0 0 1 2.7-1.408h6.272a.806.806 0 0 1 0 1.611H94.7a.516.516 0 0 0 0 1.031h3.939a1.835 1.835 0 0 0 1.532-.825l4.743-4.661a.8.8 0 0 1 .907-.153l.029.014a.778.778 0 0 1 .225 1.258l-5.894 5.886a3.854 3.854 0 0 1-2.743 1.136h-4.216a2.209 2.209 0 0 0-1.776.889l-.679.924a.516.516 0 1 0 .825.619l.685-.924a1.173 1.173 0 0 1 .942-.478h4.213a4.88 4.88 0 0 0 3.473-1.444l5.89-5.882a1.808 1.808 0 0 0-.522-2.92l-.029-.014a1.827 1.827 0 0 0-2.062.355l-.619.6V9.656a1.26 1.26 0 0 0-1.251-1.256zm-6.329 1.029h2.269v3.986l-.825-.619a.516.516 0 0 0-.619 0l-.825.619zm2.65 10h-6.271a4.3 4.3 0 0 0-.662.054V9.656a.229.229 0 0 1 .227-.227h3.025v5.007a.516.516 0 0 0 .825.412l1.343-.986 1.347.994a.516.516 0 0 0 .825-.412V9.429h3.021a.227.227 0 0 1 .227.227v8.831l-2.184 2.155a1.826 1.826 0 0 0-1.722-1.211z",
    transform: "translate(-86.027 -6.398)",
    style: {
      fill: "#0a243f"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityProductIcon);
export default __webpack_public_path__ + "static/media/QualityProductIcon.05d65cd56b260e402aca1a104cdc0dc1.svg";
export { ForwardRef as ReactComponent };